import { GLContext } from 'nanogl/types'
import UnlitPass from 'nanogl-pbr/UnlitPass'

export function backgroundStencil(gl: GLContext, pass: UnlitPass) {
  pass.glconfig.enableStencil(true)
  pass.glconfig.colorMask(false, false, false, false)
  pass.glconfig.stencilFunc(gl.ALWAYS, 1, 0xff)
  pass.glconfig.stencilOp(gl.KEEP, gl.KEEP, gl.REPLACE)
}

export function backgroundCutout(gl: GLContext, pass: UnlitPass) {
  pass.glconfig.enableStencil(true)
  pass.glconfig.stencilFunc(gl.ALWAYS, 0, 0xff)
  pass.glconfig.stencilOp(gl.KEEP, gl.KEEP, gl.REPLACE)
}

export function backgroundLayer(gl: GLContext, pass: UnlitPass) {
  pass.glconfig.enableStencil(true)
  pass.glconfig.stencilFunc(gl.EQUAL, 1, 0xff)
  pass.glconfig.stencilOp(gl.KEEP, gl.KEEP, gl.KEEP)
}
